module.exports = __webpack_public_path__ + "img/lssws_img.d39ef8e7.png";